import { track, trackCustom } from '../lib/pixel'

/** Fire a Meta Pixel event from anywhere in the UI (sections, observers, etc.). */
export function trackPixel(event: string, data?: Record<string, any>) {
  track(event, data)
}

/**
 * Fire a Meta Pixel event, then navigate to the checkout URL. The short delay
 * gives the pixel beacon time to send before the page unloads.
 */
export function trackAndNavigate(
  event: string,
  data: Record<string, any>,
  url: string,
) {
  track(event, data)
  window.setTimeout(() => {
    window.location.href = url
  }, 250)
}

export { track, trackCustom }
